import React, { useState } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { FaAmazon } from "react-icons/fa";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import BusinessModelsSection from '../businessModels';
import { Helmet } from 'react-helmet';
import { SiWoocommerce, SiPrestashop, SiShopify } from "react-icons/si";
import '../../../../index.css';
import get1 from '../../../../assests/Web_Img_Getit/1.png';
import get2 from '../../../../assests/Web_Img_Getit/2.png';
import get3 from '../../../../assests/Web_Img_Getit/3.png';
import get4 from '../../../../assests/Web_Img_Getit/4.png';
import get5 from '../../../../assests/Web_Img_Getit/5.png';
import get6 from '../../../../assests/Web_Img_Getit/6.png';
import get7 from '../../../../assests/Web_Img_Getit/7.png';
import get8 from '../../../../assests/Web_Img_Getit/8.png';
import e1 from './E- commerce Icon (2)/8.png'
import e2 from './E- commerce Icon (2)/10.png'
import e3 from './E- commerce Icon (2)/11.png'
import Team from '../../../../assests/servicePage.png';
import Service from '../../../../assests/service.png'
import bgimage from '../../../../assests/webiconF (3)/6.png'
const tabs = [
  {
    title: "1. Shopify-Magento",
    content: (
      <p className="lg:text-[19px] text-[34px] text-[#0A2C4C] font-recoleta">
        We evaluate all candidates and shortlist only those who align with the client’s business, technical, and cultural requirements.
      </p>
    ),
  },
  {
    title: "2. Free E-Commerce Consulting",
    content: (
      <>
        <h4 className="text-xl font-semibold text-[#0A2C4C] font-recoleta mb-2">Battery replacement</h4>
        <p className="lg:text-[19px] text-[34px] text-[#0A2C4C]">
          Your device may get switched off often despite charging it. Whether it is battery draining quickly or not holding charge, we offer replacement and warranty.
        </p>
        <img
          src="https://static.zohocdn.com/sites/stock-images/images/zpstock-image-1263.webp"
          alt="Battery replacement"
          className="w-full max-w-md mt-4 rounded-md"
        />
      </>
    ),
  },
  {
    title: "3. E-commerce Development",
    content: <p className="lg:text-[19px] text-[34px] text-[#0A2C4C]">We ensure smooth onboarding of selected candidates by handling documentation and welcome sessions.</p>,
  },
  {
    title: "4. Manage & Maintain your Application",
    content: <p className="lg:text-[19px] text-[34px] text-[#0A2C4C]">We ensure smooth onboarding of selected candidates by handling documentation and welcome sessions.</p>,
  },
  {
    title: "5. Cloud Consulting",
    content: <p className="lg:text-[19px] text-[34px] text-[#0A2C4C]">We ensure smooth onboarding of selected candidates by handling documentation and welcome sessions.</p>,
  },
  {
    title: "6.Payment Gateway Integration",
    content: <p className="lg:text-[19px] text-[34px] text-[#0A2C4C]">We ensure smooth onboarding of selected candidates by handling documentation and welcome sessions.</p>,
  },
  {
    title: "7.CMS Development",
    content: (
      <>
        <h1 className="text-2xl font-bold mb-4">GETIT</h1>
        <Swiper
          modules={[Autoplay]}
          spaceBetween={10}
          slidesPerView={5}
          loop={true}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          className="mb-4"
        >
          {[get1, get2, get3, get4, get5, get6, get7, get8].map((img, index) => (
            <SwiperSlide key={index}>
              <img src={img} alt={`getit-${index}`} className="w-full h-auto rounded-md" />
            </SwiperSlide>
          ))}
        </Swiper>
        <p className="lg:text-[19px] text-[34px] text-[#0A2C4C]">
          Getit is your trusted companion for daily needs, revolutionizing the way you shop from local stores across India. This user-friendly app connects you seamlessly to a network of local suppliers, ensuring that everything from groceries to essentials is just a tap away. With Getit, you can effortlessly browse and purchase over 10,000 products including fresh fruits, vegetables, dairy items, household essentials, and more.
        </p>
      </>
    )
  }

];

const tab = [
  {
    name: "Platforms",
    items: [
      { name: "Shopify", icon: <SiShopify /> },
      // { name: "Amazon", icon: <FaAmazon /> },
      { name: "Open Cart", icon: <FaAmazon /> },
      { name: "Wordepress", icon: <FaAmazon /> },
      { name: "Woo Commerce", icon: <SiWoocommerce /> },
      { name: "PrestaShop", icon: <SiPrestashop /> },
      { name: "Magento ", icon: <img src="https://cdn-icons-png.flaticon.com/512/825/825456.png" className='lg:w-14 w-28' /> },
      { name: "Vue.js", icon: <img src='https://www.vertexinc.com/sites/default/files/styles/1_91_1_ratio_for_social_media_sharing/public/2017-10/MagentoOpenSource-344x344-%402x.png?itok=AO6n0nZu' className='lg:w-20 w-40' /> },
    ],
  },

];

const services = [
  {
    icon: e1,
    title: "E-commerce consulting & Development ",
    description:
      "TekIT delivers tailored e-commerce consulting and development services to help businesses build, scale, and optimize their online stores. We create seamless, user-friendly platforms with secure payment integrations, advanced features, and mobile responsiveness. Whether it's Shopify, Magento, or custom solutions, we ensure your e-commerce presence drives engagement and conversions.",
  },
  {
    icon: e2,
    title: "Shopify E-commerce Development",
    description:
      "TekIT specializes in building high-performing, customized Shopify stores tailored to your brand and business goals. From store setup and theme customization to app integration and performance optimization, we provide end-to-end Shopify solutions. Our focus is on creating seamless, mobile-friendly, and conversion-driven shopping experiences that scale with your growth.",
  },
  {
    icon: e3,
    title: "Magento Development",
    description:
      "TekIT offers robust and scalable Magento development services for businesses seeking powerful, feature-rich online stores. From custom theme design and module development to performance tuning and third-party integrations, we build Magento solutions that deliver flexibility, security, and high performance. Our goal is to create tailored e-commerce experiences that drive sales and support long-term growth.",
  },
  // {
  //   icon: "https://www.tekitsolution.com/webmaint.png",
  //   title: "Manage & Maintain your Application",
  //   description:
  //     "We ensure smooth onboarding of selected candidates by handling documentation and welcome sessions",
  // },
  // {
  //   icon: "https://www.tekitsolution.com/webmaint.png",
  //   title: "Cloud Consulting",
  //   description:
  //     "We ensure smooth onboarding of selected candidates by handling documentation and welcome sessions",
  // },
  // {
  //   icon: "https://www.tekitsolution.com/webmaint.png",
  //   title: "Payment Gateway Integration",
  //   description:
  //     "We ensure smooth onboarding of selected candidates by handling documentation and welcome sessions",
  // },
  // {
  //   icon: "https://www.tekitsolution.com/webmaint.png",
  //   title: "CMS Development",
  //   description:
  //     "We ensure smooth onboarding of selected candidates by handling documentation and welcome sessions",
  // },
];

const ECommerce = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeTab, setActiveTab] = useState("Platforms");
  const currentTab = tab.find((t) => t.name === activeTab);

  const [message, setMessage] = useState('');

  const [formData, setFormData] = useState({
    phone: '',
    email: '',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const validate = () => {
    let newErrors = {};
    if (!formData.phone.trim()) newErrors.phone = 'Phone is required';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      try {
        // Add a "type" to formData before sending
        const payload = {
          ...formData,
          type: 'E_Commerce',
        };

        const response = await fetch('https://www.tekitsolution.com/email_apis.php?action=service', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams(payload).toString(),
        });

        const result = await response.json();
        alert('Form submitted successfully!');

        // Reset form
        setFormData({
          type: 'E_Commerce',
          phone: '',
          email: '',
        });
        setMessage('Message sent successfully!');
        setErrors({});
      } catch (error) {
        console.error('Error:', error);
        alert('Something went wrong. Please try again.');
      }
    } else {
      setErrors(validationErrors);
      setMessage('');
    }
  };

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  const handleSelect = (index) => {
    setActiveIndex(index)
  }

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true, // whether animation should happen only once
    });
  }, []);

  return (
    <div className=''>
      <Helmet>
        <title>E-commerce Development Services | Build & Optimize Your Online Store </title>
        <meta name="description" content="Grow your business with our e-commerce development services. We create user-friendly, scalable online stores tailored to your needs for maximum sales and performance." />
        <meta name="keywords" content="eCommerce Development, Custom eCommerce Solutions, eCommerce Website Development, Online Store Development, eCommerce Platform Integration, Magento eCommerce Development, Shopify Development, WooCommerce Development, Top IT Staff Augmentation Companies, IT Staffing Services, Largest IT Staffing Companies, Staffing IT, Contract IT Staffing, Staffing IT Services, IT Staffing, Staffing Solutions, IT Staffing Solutions, Premier Staffing Solutions, IT Services, Executive Staffing, Staffing Company, staffing services" />
      </Helmet>
      <div className="curslide">
        {/* Background Image with Gradient Overlay */}
        <div
          className="w-full lg:h-[380px] h-[500px] bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${Service})` }}
        // style={{
        //   backgroundImage: `linear-gradient(to right, rgba(254, 247, 237, 1), rgba(255, 255, 255, 0)), url('https://static.zohocdn.com/sites/stock-images/images/zpstock-image-39.jpg')`,
        // }}
        ></div>

        {/* Hero Content */}
        <div className="absolute top-0 left-0 w-full h-full flex items-start justify-start">
          <div className="container mx-auto px-4 py-8">
            <div className="flex flex-col justify-start items-start h-full" style={{ placeItems: 'center' }}>
              <div className="w-full  mt-52 lg:mt-[100px]">
                <div className='flex justify-center items-center'>
                  <img src={bgimage} className="w-20" />
                </div>
                <h2 data-aos="fade-up" className="text-center font-bold text-black font-recoleta text-[58px] 2xl:text-[50px] lg:text-[46px]">
                  E-commerce Solutions
                </h2>
                <p className='text-center text-bold lg:text-[24px] text-[28px] 2xl:text-[28px] '>Boost your Sales with Engaging, User-Friendly E-commerce Platforms.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <section className="px-4 py-10 bg-white">
          <div className="text-center mb-8">
            <h1 className="font-recoleta text-[54px] lg:text-[36px]" data-aos="fade-up">Digital Transformation of your Product</h1>
          </div>

          <div className="grid grid-cols-1  lg:grid-cols-3 gap-6 max-w-7xl mx-auto mb-10">
            {services.map((service, idx) => (
              <div
                key={idx}
                className="bg-white border border-gray-200 rounded-lg p-6 shadow-md hover:shadow-lg transition duration-300"
              >
                <div className="flex justify-center mb-4">
                  <img
                    src={service.icon}
                    alt={`${service.title} Icon`}
                    className="lg:w-40 w-80 h-80 lg:h-40 object-contain"
                  />
                </div>
                <h3 className="lg:text-xl text-[44px] font-semibold text-[#0A2C4C] text-center mb-3">{service.title}</h3>
                <p className="text-gray-700 text-[34px] lg:text-[18px] text-center">{service.description}</p>
                {/* <div className="mt-4 text-center">
                  <a
                    href="#"
                    className="text-[#F86F4B] font-semibold hover:underline transition"
                  >
                    Read More
                  </a>
                </div> */}
              </div>
            ))}
            {/* {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveIndex(index)}
            className={`flex flex-col items-center text-center p-6 rounded-xl transition border-2 shadow-sm ${
              activeIndex === index
                ? "border-[#F86F4B] bg-[#fff6f3]"
                : "border-gray-200 hover:border-[#F86F4B]"
            }`}
          >
            <h4 className="text-lg font-semibold text-[#0A2C4C] mb-2">{tab.title}</h4>
            <p className="text-sm text-[#0A2C4C]">{tab.description}</p>
          </button>
        ))}
      </div> */}

            {/* Tab Content */}
            {/* <div className="bg-gray-50 max-w-4xl mx-auto p-6 rounded-xl shadow-md font-recoleta"> */}
            {/* {tabs[activeIndex].content} */}
          </div>

          {/* <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 max-w-7xl mx-auto relative z-0">
            <div className="space-y-2 overflow-auto h-[400px] scrollbar-hidden col-span-1 z-1 relative">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  className={`w-full text-left px-4 py-3 rounded-md font-recoleta transition text-[44px] lg:text-lg ${activeIndex === index
                    ? "text-[#F86F4B] border-r-4 border-[#F86F4B] bg-[#fef2f2]"
                    : "text-[#0A2C4C] hover:text-[#F86F4B] hover:bg-gray-100"
                    }`}
                  onClick={() => handleSelect(index)}
                >
                  {tab.title}
                </button>
              ))}
            </div>
            <div className="col-span-1 lg:col-span-3 bg-gray-50 p-6 rounded-lg shadow-md h-fit relative z-0 font-recoleta">
              {tabs[activeIndex].content}
            </div>
          </div> */}
        </section>
        <section className="relative py-10 text-white font-recoleta">
          <img
            src={Team}
            alt="img"
            className="absolute inset-0 w-full h-full object-cover z-0"
          />
          <div className="absolute inset-0 z-0"></div>
          <div className="relative z-1 container mx-auto px-4">
            <div className="text-center mb-8">
              <h2 data-aos="fade-up" className="2xl:text-[40px] lg:text-[32px] text-[54px] font-bold mb-2">
                <strong>Technologies</strong> We Work With
              </h2>
              <p data-aos="fade-up" className="2xl:text-[26px]  lg:text-[20px] text-[34px]">
                Check out what programming languages, database systems, and platforms we use to complete projects for{" "}
                our clients
              </p>
            </div>

            <div className="flex flex-wrap justify-center lg:gap-4 gap-8 mb-8">
              {tab.map((tab) => (
                <button
                  key={tab.name}
                  onClick={() => setActiveTab(tab.name)}
                  className={`px-8 2xl:text-[32px]  lg:text-[26px] text-[23px] py-2 rounded-3xl  font-medium transition ${activeTab === tab.name
                    ? "bg-white text-black shadow"
                    : "bg-transparent text-white border border-white hover:text-white hover:border-white"
                    }`}
                >
                  {tab.name}
                </button>
              ))}
            </div>

            {/* Tab Content */}
            <div className="flex gap-4 justify-center mb-6">

            </div>

            {/* Tech Icons */}
            <div className="grid lg:grid-cols-4 grid-cols-2 justify-self-center flex-wrap justify-center gap-6">
              {currentTab?.items.map((tech) => (
                <div
                  key={tech.name} data-aos="fade-up"
                  className="bg-white text-black lg:w-44 lg:p-0 p-10 lg:h-44 lg:mt-0 mt-10 rounded-lg shadow flex flex-col items-center justify-center"
                >
                  <div className="lg:text-4xl text-[80px] mb-2">{tech.icon}</div>
                  <p className="2xl:text-[24px]  lg:text-[20px] text-[60px] font-medium text-center">{tech.name}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <BusinessModelsSection />
        <div className="p-4 lg:p-10 lg:px-48 px-10 bg-white font-recoleta">
          <h2 data-aos="fade-up" className="text-[54px] 2xl:text-[40px] lg:text-[32px] text-center font-bold text-[#002856] mb-8 font-recoleta">
            Schedule Call
          </h2>

          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* <div>
                <input
                  data-aos="fade-up"
                  name="name"
                  placeholder="Name *"
                  className="w-full border border-gray-300 lg:p-4 p-8 rounded placeholder:text-[32px] lg:placeholder:text-[20px]"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && <p className="text-red-500 lg:text-sm text-[24px]">{errors.name}</p>}
              </div> */}

              <div>
                <input
                  data-aos="fade-up"
                  name="email"
                  placeholder="Email *"
                  className="w-full border border-gray-300 p-4 rounded text-[32px] lg:text-[20px]"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && <p className="text-red-500 text-[24px] lg:text-sm">{errors.email}</p>}
              </div>

              <div>
                <input
                  data-aos="fade-up"
                  name="phone"
                  placeholder="Phone"
                  className="w-full border border-gray-300 p-4 rounded text-[32px] lg:text-[20px]"
                  value={formData.phone}
                  onChange={handleChange}
                />
                {errors.phone && <p className="text-red-500 lg:text-sm text-[24px]">{errors.phone}</p>}

              </div>
            </div>

            <div className="justify-center gap-4 mt-6 grid grid-cols-1 px-10  lg:hidden justify-self-center">
              <button
                type="submit"
                className="bg-[#00447b] w-full text-white py-2 px-6 rounded-full hover:bg-[#00325c] duration-300 text-[28px] lg:text-[20px]"
              >
                Submit
              </button>
              {/* <button
                type="button"
                data-aos="fade-up"
                onClick={'handleReset'}
                className="bg-[#00447b] w-full text-white lg:mt-0 mt-4 py-2 px-6 rounded-full hover:bg-[#00325c] duration-300 text-[28px] lg:text-[20px]"
              >
                Reset
              </button> */}
            </div>
            <div className="justify-center gap-4 mt-6 lg:flex px-10 lg:block hidden">
              <button
                type="submit"
                data-aos="fade-up"
                className="bg-[#00447b] lg:w-52 w-full text-white py-2 px-6 rounded-full hover:bg-[#00325c] duration-300"
              >
                Submit
              </button>
              {/* <button
                type="button"
                data-aos="fade-up"
                onClick={handleReset}
                className="bg-[#00447b] lg:w-52 w-full text-white lg:mt-0 mt-4 py-2 px-6 rounded-full hover:bg-[#00325c] duration-300"
              >
                Reset
              </button> */}
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ECommerce;